/**
 * The one countdown sentence for an automatic retry while QuoteMaker's server
 * is not answering (outage lane, 2026-09-29). Shared by the page-load outage
 * screen and the login form so both say the same thing the same way.
 */
export function secondsUntil(nextRetryAt: number | null | undefined, now: number): number | null {
    if (!nextRetryAt) return null;
    return Math.max(0, Math.ceil((nextRetryAt - now) / 1000));
}

export function retryCountdownText(seconds: number | null): string {
    if (seconds === null || seconds <= 0) return 'Checking now.';
    return `Trying again in ${seconds} ${seconds === 1 ? 'second' : 'seconds'}.`;
}
